'use client';

import { LanguageLink } from '@graphql/generated-contentful/graphql';
import { useChangeLocale } from '@lib/hooks/useChangeLocale';
import { useParams } from 'next/navigation';
import { FooterMenuItem } from './FooterMenu/FooterMenuItem';
import { FooterMenuLabel } from './FooterMenu/FooterMenuLabel';

type FooterLanguageMenuListProps = {
  label?: string;
  languages?: LanguageLink[];
};

export const FooterLanguageMenuList = ({
  label,
  languages,
}: FooterLanguageMenuListProps) => {
  const params = useParams();

  const handleChangeLocale = useChangeLocale();
  if (!languages) {
    return null;
  }

  return (
    <div className="col-span-6 md:col-span-4 lg:col-span-2">
      {label && <FooterMenuLabel text={label} />}
      <ul>
        {languages &&
          languages?.length > 0 &&
          languages.map((language) => {
            const locale = language.locale ?? '';
            const isCurrentLang = locale === params?.locale;
            return (
              <FooterMenuItem key={language.title}>
                <button
                  className="focus-outline rounded text-grey-500 hover:text-blue-dark"
                  data-test={`language-${locale}`}
                  onClick={() => handleChangeLocale(locale)}
                  lang={isCurrentLang ? undefined : locale}
                  aria-pressed={isCurrentLang ? 'true' : 'false'}
                >
                  <span>{language.title}</span>
                </button>
              </FooterMenuItem>
            );
          })}
      </ul>
    </div>
  );
};
